import React from 'react';
import { useState, useContext } from 'react';
import { Link } from 'react-router-dom';

import axios_api from '../Api';
import { API_URL, AUTH_TOKEN } from '../Context';
import { BLOCKS, OLD_LK_URL } from '../blocks';


function ContractStatusText(order) {
  if (!order?.order_form_pdf) {
    return 'заказ не оформлен';
  }

  switch (order.approve_status) {
    case 'NO_CONTRACT':
      return 'оформлен бланк заказа, договор не сформирован';
    case 'DRAFT':
      return 'сформирован черновик договора';
    case 'SENT':
      return 'договор отправлен на подписание в АСНП ЦВКК';
    case 'APPROVED':
      return order.sign_status === 'BOTH_SIGNED' ?
        'договор подписан двумя сторонами' :
        'договор утвержден и подписан АСНП ЦВКК';
    case 'REJECTED':
      return 'договор отклонен АСНП ЦВКК';
    case 'APPROVED_DOCS_REJECTED':
      return 'документы возвращены АСНП ЦВКК, необходимо загрузить верные документы';
    default:
      return '';
  }
}


function BlockCard({block}) {
  return (
    <div className="col-4">
      <Link className="lk-block-card" to={block.path}>
        <i className={`bi ${block.icon} lk-block-card-icon`}></i>
        <h4 className="mt-3">{block.title}</h4>
        <p className="mb-0">{block.description}</p>
      </Link>
    </div>
  );
}


export default function MainPage({appUserName, order, orderLoading, selectedYear}) {
  // null — профиль еще загружается, пустая строка — организация не указана
  const [organization, setOrganization] = useState(null);
  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);

  React.useEffect(() => {

    let userProfile = axios_api.get(api_url + '/profile/', {
      headers: {"Authorization": token}
    });

    userProfile.then(
      (result) => {
        setOrganization(result.data.organization || '');
      },
      (error) => {
        console.log(error);
        setOrganization('');
      }
    );

  }, [api_url, token]);

  const contractStatus = orderLoading ? '' : ContractStatusText(order);

  return (
    <div className="m-3 me-5">
      <div className="lk-info-panel p-4 mb-4">
        <h4 className="mb-3">
          {organization === null ?
            <span className="loader loader-sm" role="status" aria-label="Загрузка"></span>
          :
            (organization || `Лаборатория ${appUserName}`)
          }
        </h4>
        <p className="mb-1">Код участника: <b className='ms-2'>{appUserName}</b></p>
        <p className="mb-0">Договор {selectedYear}: <b className='ms-2'>{contractStatus}</b></p>
      </div>

      <div className="row g-4 mb-4">
        <BlockCard block={BLOCKS.documents} />
        <BlockCard block={BLOCKS.results} />
        <BlockCard block={BLOCKS.certificates} />
      </div>

      <a className="lk-old-lk-panel" href={OLD_LK_URL} target="_blank" rel="noopener noreferrer">
        <i className="bi bi-box-arrow-up-right me-2"></i>
        Перейти в старый личный кабинет 
      </a>
    </div>
  );
}
